import * as React from 'react';
import { connect } from 'react-redux';

import Header from '../static/Header';
import Modal from '../static/Modal';
import Icon from '../static/Icons';
import { Button } from '../static/Elements';
import JobTitleList from './JobTitleList';
import {TitlesLayout} from '../static/Layouts';
import CreateTitle from './CreateTitle';
import {
  getTitles,
  removeTitle,
  createTitle,
} from "../../data/titles/titleActions";

import createLogger from '../../utils/createLogger';
const DEBUG = false;
const debug = createLogger(DEBUG, `Titles.js`);

class Titles extends React.Component {


  /* ------------ lifecycle methods ------------ */
  constructor(props) {
    super(props);
    debug.enter(`constructor`);
    this.state = {
      modalIsOpen: false
    }
  }

  componentDidMount(){
    const {getTitles} = this.props;
    getTitles();
  }

  /* ------------ event handlers ------------ */

  openModal = () => this.setState({modalIsOpen: true});
  closeModal = () => this.setState({modalIsOpen: false});

  /* ------------ rendering ------------ */

  render() {

    const {
      modalIsOpen,
    } = this.state;

    const {
      openModal,
      closeModal,
    } = this;

    const {
      titles,
      categories,
      removeTitle,
      createTitle,
    } = this.props;

    const listConfig = {
      titles,
      categories,
      removeTitle,
    };

    return (
        <TitlesLayout>
          <Modal title="Add a Job Title"
               isOpen={modalIsOpen}
               close={closeModal}>
            <CreateTitle createTitle={createTitle}
                         closeModal={closeModal}
                         categories={categories}
                         titles={titles}/>
          </Modal>

          <Header top>
          </Header>

          {
            !!titles && titles !== 'error' ? (
                <JobTitleList {...listConfig}>
                  <Button primary onClick={openModal}>
                    <Icon.Add/> Add Title
                  </Button>
                </JobTitleList>
            ) : null
          }
        </TitlesLayout>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    titles: {
      includes: state.titles.includes_cache,
      excludes: state.titles.excludes_cache,
    },
    categories: state.titles.categories,
  }
};

export default connect(mapStateToProps, {
  getTitles,
  removeTitle,
  createTitle,
})(Titles);


// WEBPACK FOOTER //
// ./src/components/Titles/Titles.js